import constant from "../../constant";

const api = constant.api + "backup";

const state = () => ({
  result: null,
  
});

const getters = {
  getResult: (state) => state.result,
};

const actions = {
  run({ commit }) {
    

    return this.$api
      .create(api + "/run", {})
      .then((response) => {
        commit("setResult", response.data);
      })
  },
};

const mutations = {
  setResult(state, payload) {
    state.result = payload;
  },
  
  
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
